<template>
  <div>
    <b-tabs
      pills
      justified
    >
      <b-tab
        active
        lazy
      >
        <template #title>
          <feather-icon icon="BoxIcon" />
          <span>Güncel Stoklar</span>
        </template>
        <day-durations />
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon icon="BoxIcon" />
          <span>Tahsis Stoklar</span>
        </template>
        <allocations />
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon icon="BoxIcon" />
          <span>Devreden Stoklar</span>
        </template>
        <last-month />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import {
  BTabs, BTab,
} from 'bootstrap-vue'
import DayDurations from '@/views/Sales/Stocks/DayDurations.vue'
import Allocations from '@/views/Sales/Stocks/Allocations.vue'
import LastMonth from '@/views/Sales/Stocks/LastMonth.vue'

export default {
  name: 'Stocks',
  components: {
    BTabs,
    BTab,
    DayDurations,
    Allocations,
    LastMonth,
  },
}
</script>
